export const lang = new URL(location.href).searchParams.get('lang') || 'en'
